import { formatDateTimeVN } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'
import { formatCountdown, getSLAState } from '@/lib/sla-utils'

interface Props {
    deadlineAt?: string
    breached: boolean
    warningAt?: string
}

export function OrderSLAPanel({ deadlineAt, breached, warningAt }: Props) {
    const state = getSLAState(deadlineAt, breached, warningAt)
    if (state === 'none') return null

    const countdown = deadlineAt ? formatCountdown(deadlineAt) : ''
    const deadlineFormatted = deadlineAt ? formatDateTimeVN(deadlineAt) : ''

    const containerClass =
        state === 'breached'
            ? 'border-destructive/50 bg-destructive/10 text-destructive'
            : state === 'warning'
              ? 'border-amber-500/60 bg-amber-50 text-amber-900 dark:bg-amber-950/40 dark:text-amber-200'
              : 'border-border bg-muted/30'

    return (
        <div
            className={`rounded-md border px-4 py-3 text-sm flex items-center justify-between gap-4 ${containerClass}`}
        >
            <div className="flex items-center gap-2">
                <span className="font-medium">{m.sla_deadline()}:</span>
                <span>{deadlineFormatted}</span>
            </div>
            {state === 'breached' ? (
                <span className="font-semibold">{m.sla_overdue()}</span>
            ) : state === 'warning' ? (
                <span className="font-semibold">
                    {m.sla_almost_overdue()}
                    {countdown ? ` · ${countdown} ${m.sla_remaining()}` : ''}
                </span>
            ) : countdown ? (
                <span className="text-muted-foreground">
                    {countdown} {m.sla_remaining()}
                </span>
            ) : null}
        </div>
    )
}
